import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  makeRequest,
  makeRequestSelector,
  removeRequest as removeStoreRequest,
  useAppDispatch,
  useAppSelector,
} from '@wappsto/redux';
import { randomID } from '../util';

export default function useRequest(id?: string, removeOldRequest?: boolean) {
  const dispatch = useAppDispatch();
  const [requestId, setRequestId] = useState<string>(() => id || randomID());
  const getRequest = useMemo(() => makeRequestSelector(), []);
  const request = useAppSelector(state => getRequest(state, requestId));

  const removeRequest = useCallback(() => {
    dispatch(removeStoreRequest(requestId));
  }, [dispatch, requestId]);

  const send = useCallback(
    (obj: any) => dispatch(makeRequest({ ...obj, id: requestId })),
    [dispatch, requestId],
  );

  useEffect(
    () => () => {
      if ((removeOldRequest && requestId) || (!id && removeOldRequest !== false)) {
        removeRequest();
      }
    },
    [removeOldRequest, requestId, removeRequest, id],
  );

  return { request, requestId, setRequestId, send, removeRequest };
}
